import { Component, forwardRef, OnInit, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS, Validator, FormControl, FormGroup} from '@angular/forms';
declare var $: any;

const noop = () => {
};

@Component({
  selector: 'ats-campo-telefone',
  templateUrl: './campo-telefone.component.html',
  styleUrls: ['./campo-telefone.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => CampoTelefoneComponent), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => CampoTelefoneComponent), multi: true }
  ]
})
export class CampoTelefoneComponent implements OnInit {

  @Input() label: string = '';
  @Input() className: string = '';
  @Input() campoObrigatorio: boolean = false;
  @Input() desativado: boolean = false;
  @Input() formControlName: string;
  @Input() formGroup: FormGroup;

  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  private idComponent: number;
  public classCampo : string;
  public classError : string;
  private inputCampo : string;
  private errorCampo : string;

  constructor() { }

  ngOnInit() {
    var self = this;
    this.idComponent = Math.floor(Math.random() * 600) + 1;
    this.classCampo = 'campo-telefone-' + this.idComponent;
    this.classError = 'error-campo-telefone-' + this.idComponent;
    this.inputCampo = 'input.' + this.classCampo;
    this.errorCampo = 'div.' + this.classError;

    $('body').on('blur', this.inputCampo, function(e){
      var value = $.trim($(this).val());
      var input = this;
      if(self.campoObrigatorio && value == ''){
        $(input).removeClass('ng-valid').addClass('ng-invalid');
        $(self.errorCampo).html('Campo obrigatório');
        $(self.errorCampo).show();
      }else{
        if($.ats._validaTelefone(value)){
          $(input).removeClass('ng-invalid').addClass('ng-valid');
          $(self.errorCampo).hide();
        }else{
          $(input).removeClass('ng-valid').addClass('ng-invalid');
          $(self.errorCampo).html('Número inválido');
          $(self.errorCampo).show();
        }
      }
    });

    $(function(){
      $(self.inputCampo).bind('keypress', $.ats._somenteNumero);

      $(self.inputCampo).bind('paste', function (e) {
        e.preventDefault();
      });

      $(self.inputCampo).focusout(function(){
        var phone, element;
        element = $(this);
        element.unmask();
        phone = element.val().replace(/\D/g, '');
        if(phone.length > 10) {
            element.mask("(99) 99999-9999");
        } else {
            element.mask("(99) 9999-99999");
        }
      }).trigger('focusout');


    });

  }

  public writeValue(value: any) {  }

  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  validaTelefone(c: FormControl) : any{
    var value: string = '';
    var retorno : any = {};

    if((c.value != undefined && c.value != null) || (c.value != undefined && c.value != null && c.value[this.formControlName] != undefined)){

      if(c.value != undefined && c.value != null && c.value[this.formControlName] != undefined){
          value = c.value[this.formControlName];
      }else{
          value = c.value;
      }

      if(this.campoObrigatorio && $.ats._empty(value)){
        retorno['validateObrigatorio'] = {};
        retorno['validateObrigatorio']['valid'] = false;
      }else{
        if(!$.ats._empty(value) && !$.ats._validaTelefone(value) ){
          retorno['validateTelefoneInvalido'] = {};
          retorno['validateTelefoneInvalido']['valid'] = false;
        }else{
          retorno = null;
        }
      }
    }else{
      retorno = null;
    }

    return retorno;
}

  public validate(c: FormControl) {
    return this.validaTelefone(c);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/componentes/campo-telefone/campo-telefone.component.ts